import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

function EditModal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 p-4 backdrop-blur-md">
      <div className="bg-gradient-secondary rounded-xl max-w-2xl w-full overflow-none p-4 sm:p-8">
        <div className="p-6 flex justify-between items-center">
          <h3 className="text-xl">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 transition ease-in-out duration-300 hover:text-white"
          >
            <CloseIcon></CloseIcon>
          </button>
        </div>
        <hr className="mt-2 mb-4 border-white/20 w-full" />
        <div className="p-6 overflow-y-auto max-h-[75vh]">{children}</div>
      </div>
    </div>
  );
}

export default EditModal;
